import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import AutomationService from 'services/AutomationService'

export const initialState = {
  automation: null,
  automationIsLoading: false,
  catalog: null,
  catalogIsLoading: false,
  categories: null,
  credential: null,
  credentialIsLoading: false,
  credentialsIsLoading: false,
}

export const listCatalog = createAsyncThunk(
  'automation/listCatalog',
  async ({ page, limit }, { rejectWithValue }) => {
    try {
      return await AutomationService.getCatalogList(page, limit)
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const listCategory = createAsyncThunk(
  'automation/listCategory',
  async (_, { rejectWithValue }) => {
    try {
      return await AutomationService.getCategoryList()
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const listAutomation = createAsyncThunk(
  'automation/listAutomation',
  async ({ page, limit }, { rejectWithValue }) => {
    try {
      return await AutomationService.getAutomationList(page, limit)
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const listCredential = createAsyncThunk(
  'automation/listCredential',
  async (_, { rejectWithValue }) => {
    try {
      return await AutomationService.getCredentialList()
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const createCredential = createAsyncThunk(
  'automation/createCredential',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await AutomationService.createCredential(data)
      dispatch(listCredential())
      return response
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const deleteCredential = createAsyncThunk(
  'automation/deleteCredential',
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const response = await AutomationService.deleteCredential(id)
      dispatch(listCredential())
      return response
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const automationSlice = createSlice({
  name: 'automation',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(listCatalog.fulfilled, (state, action) => {
      state.catalog = action.payload
    })
    builder.addCase(listCategory.fulfilled, (state, action) => {
      state.categories = action.payload
    })
    builder.addCase(listAutomation.pending, state => {
      state.automationIsLoading = true
    })
    builder.addCase(listAutomation.fulfilled, (state, action) => {
      state.automationIsLoading = false
      state.automation = action.payload
    })
    builder.addCase(listAutomation.rejected, state => {
      state.automationIsLoading = false
    })
    builder.addCase(listCredential.pending, state => {
      state.credentialsIsLoading = true
    })
    builder.addCase(listCredential.fulfilled, (state, action) => {
      state.credentialsIsLoading = false
      state.credentials = action.payload
    })
    builder.addCase(listCredential.rejected, state => {
      state.credentialsIsLoading = false
    })
    builder.addCase(createCredential.pending, state => {
      state.credentialIsLoading = true
    })
    builder.addCase(createCredential.fulfilled, (state, action) => {
      state.credentialIsLoading = false
      state.credential = action.payload
    })
    builder.addCase(createCredential.rejected, state => {
      state.credentialIsLoading = false
    })
  },
})

export default automationSlice.reducer
